export default "__VITE_ASSET__mIWlnmon__"